<div class="page-header">
  <app-back-btn class="close" (click)="back()"></app-back-btn>
  <h1 class="page-title">{{ title }}</h1>
  <h3 class="page-subtitle">{{ subTitle }}</h3>
</div>
<ng-content></ng-content>
